// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { cartPageTemplateBreakpoint } from "@pace/App/Components/Cart/CartPageTemplate";
import { StyledButton } from "@pace/MobiusOverrides/Clickable/Clickable";
import { logoLinksSearchStyles } from "@pace/Overrides/Widgets/Header/LogoLinksSearch";
import { DivWrapper } from "@pace/XDL/constants";
import IconPhone from "@pace/XDL/Icons/IconPhone";
import { fontConfig } from "@pace/XDL/PreStyle/typography";
import { createLinkIconStyles, ellipsis, layoutContainer, xScreen } from "@pace/XDL/Utilities";
import { css } from "styled-components";

logoLinksSearchStyles.container = {
    css: css`
        ${layoutContainer};
        display: flex;
        justify-content: space-between;
        align-items: center;
        column-gap: 22px;
        width: 100%;

        ${({ isCheckout }: any) => {
            if (isCheckout) {
                return css`
                    ${xScreen("lte", "md")} {
                        flex-wrap: wrap;
                        row-gap: 12px;
                    }
                    ${xScreen("lt", cartPageTemplateBreakpoint)} {
                        > div:first-of-type {
                            order: 1;
                        }
                        > ${StyledButton} {
                            order: 2;
                        }
                        > ${TypographyStyle}, > div:last-of-type {
                            order: 3;
                            width: 100%;
                            > ${TypographyStyle} {
                                ${ellipsis(1)};
                            }
                        }
                    }
                `;
            }
        }}
    `,
};

logoLinksSearchStyles.logoWrapper = {
    css: css`
        padding: 0;
        margin: 0;
        display: flex;
        column-gap: 16px;
        align-items: center;

        ${({ mobileSearchOpen }: any) => {
            if (mobileSearchOpen) {
                return css`
                    display: none;
                `;
            }
        }}
    `,
};

logoLinksSearchStyles.searchMenuWrapper = {
    css: css`
        padding: 0;
        flex: 1;
    `,
};

logoLinksSearchStyles.actionsWrapper = {
    css: css`
        display: flex;
        align-items: center;
        margin-left: auto;
        column-gap: 16px;
        ${DivWrapper} {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            column-gap: 32px;

            ${xScreen("lte", "md")} {
                column-gap: 16px;
            }
        }
    `,
};

logoLinksSearchStyles.mobileSearch = {
    css: css`
        display: inline-block;
        line-height: 1;
    `,
};

logoLinksSearchStyles.titleTypography = {
    size: 12,
    lineHeight: "14px",
    weight: fontConfig.weight.regular,
    color: "common.ui7",
    ellipsis: true,
    css: css`
        display: inline-block;
        max-width: 320px;

        ${xScreen("lte", "sm")} {
            max-width: 100%;
            white-space: normal;
        }
    `,
};

logoLinksSearchStyles.titleLabelTypography = {
    size: 12,
    lineHeight: "14px",
    weight: fontConfig.weight.bold,
    color: "common.ui14",
    ellipsis: true,
    css: css`
        margin-right: 4px;
        ${xScreen("lte", "sm")} {
            margin-bottom: 8px;
            width: 100%;
        }
    `,
};

logoLinksSearchStyles.customerPhone = {
    ...createLinkIconStyles(
        IconPhone,
        {
            icon: {
                iconProps: {
                    size: 16,
                    color: "common.ui14",
                },
                position: "left",
            },
            typographyProps: {
                size: 14,
                lineHeight: "16px",
                color: "secondary",
            },
            css: css`
                margin-left: auto;
                white-space: nowrap;
            `,
        },
        undefined,
        css`
            opacity: 1;
        `,
    ),
};
